import styled, { css, keyframes } from "styled-components";

import {
  BRAND,
  BRAND_DARK,
  GRAY,
  GRAY_LIGHT,
  GRAY_LIGHTEST,
  WHITE
} from "../../colors";
import { Body } from "../../typography";

const FadeIn = keyframes`
  0% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
`;

const radioCircleStyles = (backgroundColor, fillColor) => css`
  background-image: radial-gradient(
    circle at center,
    ${backgroundColor},
    ${backgroundColor} 26%,
    ${fillColor} 30%,
    ${fillColor} 100%
  );
  border-color: ${fillColor};
`;

export const RadioInput = styled.input.attrs({
  type: "radio"
})`
  appearance: none;
  border: 1px solid ${GRAY};
  border-radius: 50%;
  background-color: ${WHITE};
  height: 20px;
  margin: -1px 12px 0 0;
  padding: 0;
  vertical-align: text-top;
  width: 20px;

  &:checked {
    animation: ${FadeIn} 300ms;
    ${radioCircleStyles(WHITE, BRAND)}
  }

  &:disabled {
    animation: none;
    background-color: ${GRAY_LIGHT};
    background-image: none;
    border: ${GRAY_LIGHT};
  }

  &:focus {
    outline: none;

    &:after {
      border: 2px solid ${BRAND_DARK};
      border-radius: 50px;
      box-sizing: content-box;
      content: "";
      height: 24px;
      left: 6px;
      position: absolute;
      top: 5px;
      width: 24px;
    }
  }
`;

export const Label = styled(Body).attrs({ as: "label" })`
  * {
    box-sizing: border-box;
  }

  background-color: transparent;
  border-radius: 4px;
  display: block;
  padding: 8px 16px 8px 10px;
  position: relative;
  transition: background-color 300ms;

  &:hover {
    background-color: ${({ disabled }) =>
      disabled ? "transparent" : GRAY_LIGHTEST};
    cursor: ${({ disabled }) => (disabled ? "initial" : "pointer")};
  }
`;
